import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes } from 'redux-form';
import { withStyles } from 'material-ui/styles';

import Grid from 'material-ui/Grid';
import Select, { optionPropType } from '../Select';
import { toInt } from '../../../lib/helpers';

import styles from '../../../constants/styles';

export class Input extends Component {
  constructor(props) {
    super(props);
    this.onManufacturerChange = this.onManufacturerChange.bind(this);
    this.onResinChange = this.onResinChange.bind(this);
  }

  onManufacturerChange(event) {
    const { input } = this.props;
    const { value, onChange } = input;
    const manufacturerId = toInt(event.target.value);

    const id = undefined;
    const newValue = Object.assign({}, value, { manufacturerId, id });

    onChange(newValue);
  }

  onResinChange(event) {
    const { input } = this.props;
    const { value, onChange } = input;

    const id = toInt(event.target.value);
    const newValue = Object.assign({}, value, { id });

    onChange(newValue);
  }

  render() {
    const {
      input,
      required,
      manufacturerOptions,
      resinOptions,
    } = this.props;
    const value = input.value;
    const disableManufacturerSelect =
      manufacturerOptions.length === 1 &&
      value.manufacturerId !== undefined;

    return (
      <Grid container>
        {!disableManufacturerSelect ? (
          <Grid item xs={12} sm={6}>
            <Select
              label="Resin Manufacturer"
              required={required}
              value={value.manufacturerId}
              onChange={this.onManufacturerChange}
              options={manufacturerOptions}
            />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={disableManufacturerSelect ? 12 : 6}>
          <Select
            label="Resin System"
            required={required}
            disabled={resinOptions.length === 0}
            value={value.id}
            onChange={this.onResinChange}
            options={resinOptions}
          />
        </Grid>
      </Grid>
    );
  }
}

Input.defaultProps = {
  required: false,

}

Input.propTypes = {
  required:            PropTypes.bool,
  manufacturerOptions: PropTypes.arrayOf(PropTypes.shape(optionPropType)).isRequired,
  resinOptions:        PropTypes.arrayOf(PropTypes.shape(optionPropType)).isRequired,
  input:               PropTypes.shape(fieldInputPropTypes).isRequired,
}

export default withStyles(styles)(Input);



// WEBPACK FOOTER //
// ./src/components/common/formComponents/ResinPicker.js